/* eslint-disable @next/next/no-img-element */
import dynamic from "next/dynamic";
import Link from "next/link";
import { FC, Fragment, Suspense, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import SearchIcon from "~/assets/svgs/search.svg";
import Button from "~/components/Button";
import Container from "~/components/Container";
import { recentKeywordState } from "~/services/recent-search/recent-search.atom";
import storeConfigAtom from "~/services/store-config/store-config.atom";
import { getTheme } from "~/utils/theme";
import SearchFilter from "../SearchFilter";
import styles from "./Header.module.scss";
import MobileHeaderTwo from "./MobileHeaderTwo";
import Image from "next/legacy/image";
import { UserAtom } from "~/services/user";
import { CartAtom } from "~/services/cart";
import Alert from "~/components/Alert";
import { NodesResponse } from "~/data/home/interface";
import useClient from "~/hooks/useClient";
import Navigation from "../Navigation";
import TopHeader from "~/components/TopHeader";
import BottomAlert from "~/components/BottomAlert";
import UserButton from "~/components/UserButton";
import WishButton from "~/components/WishButton";
import CartButton from "~/components/CartButton";

// const MobileHeader = dynamic(() => import('./MobileHeader'), { ssr: false });

// const TopHeader = dynamic(() => import('~/components/TopHeader'), {
//     ssr: false,
//     loading(loadingProps) {
//         return null; // or return a loading component
//     }
// });

// const UserButton = dynamic(() => import("~/components/UserButton"), {
//   ssr: false,
//   loading(loadingProps) {
//     return null; // or return a loading component
//   },
// });

// const WishButton = dynamic(() => import("~/components/WishButton"), {
//   ssr: false,
//   loading(loadingProps) {
//     return null; // or return a loading component
//   },
// });

// const CartButton = dynamic(() => import("~/components/CartButton"), {
//   ssr: false,
//   loading(loadingProps) {
//     return null; // or return a loading component
//   },
// });
// const Navigation: any = dynamic(async () => {
//     try {
//         return (await require(`~/theme/${getTheme()}/sections/Navigation`)).default;
//     } catch (error) {
//         return (await require(`~/sections/Navigation`)).default;
//     }
// },
//     { ssr: false, loading: () => null });

interface HeaderProps {
  menu?: NodesResponse[];
  storeConfig?: {
    frontend_config_logo: string;
  };
}

const Header: FC<HeaderProps> = ({
  menu,
  storeConfig: storeConfigServerSide,
}) => {
  const isClient = useClient();
  const [openSearch, setOpenSearch] = useState(false);
  const recoilRecentKeywords = useRecoilValue(recentKeywordState);

  const [openMenu, setOpenMenu] = useState(false);
  const storeConfig = useRecoilValue(storeConfigAtom.store);
  const [recentKeywords, setRecentKeywords] = useState<string[]>();
  const currentUser = useRecoilValue(UserAtom.currentUser);
  const Cart = useRecoilValue(CartAtom.cartSelector);

  const handleOpenSearch = () => {
    setTimeout(() => {
      setOpenSearch(!openSearch);
    }, 0);
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setRecentKeywords(recoilRecentKeywords);
    }
  }, [recoilRecentKeywords]);

  return (
    <Fragment>
      <div className={styles.header}>
        <Alert />
        <TopHeader storeConfigServerSide={storeConfigServerSide} />
        <Container
          className="flex items-center justify-around relative h-full"
          rootClassName="h-full"
        >
          <div className="flex items-center gap-1">
            <Button
              className="flex lg:!hidden !text-white"
              prefixIcon="menu1"
              shape="square"
              type="borderless"
              onClick={() => setOpenMenu(true)}
              aria-label="Menu"
            />
            <a href="/" className="flex items-center">
              {(storeConfigServerSide ?? storeConfig)?.frontend_config_logo && (
                <Image
                  src={
                    (storeConfigServerSide ?? storeConfig)
                      ?.frontend_config_logo || ""
                  }
                  alt="Logo"
                  className="w-auto h-[40px] object-contain object-left"
                  width={180}
                  height={40}
                  loading="eager"
                />
              )}
            </a>
          </div>

          <div className="flex-1 w-[500px] gap-[56px] text-center">
            <div className="hidden md:flex flex-1 justify-center">
              <Navigation menu={menu} />
            </div>
          </div>

          <div
            className="flex min-w-[180px] justify-end "
            style={{
              pointerEvents:
                currentUser?.loading || Cart?.loading ? "none" : "auto",
            }}
          >
            <Button
              prefixIcon={<SearchIcon width={24} height={24} alt="Search" />}
              shape="square"
              type="borderless"
              onClick={handleOpenSearch}
              aria-label="Search"
              className="!bg-transparent !border-transparent"
            />
            <UserButton />
            <WishButton />
            <CartButton />
          </div>
        </Container>
        <BottomAlert />

        {isClient && (
          <>
            <SearchFilter
              recentKeywords={recentKeywords?.slice(0, 5)}
              openSearch={openSearch}
              onCloseSearch={() => setOpenSearch(false)}
            />
            <MobileHeaderTwo
              open={openMenu}
              onClose={() => setOpenMenu(false)}
            />
          </>
        )}
      </div>
    </Fragment>
  );
};

export default Header;
